const SITE_URL = 'https://taigasourcing.com';

export const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Taiga Sourcing',
  url: SITE_URL,
  logo: `${SITE_URL}/logo-navy.png`,
  description: 'Taiga Sourcing connects international B2B buyers with Indian manufacturers across apparel, tiles, bathware, furniture, home decor, textiles, handicrafts, packaging, electrical, plumbing, chemicals and custom sourcing.',
  contactPoint: [
    {
      '@type': 'ContactPoint',
      telephone: '+91-90999-67671',
      contactType: 'sales',
      areaServed: 'Worldwide',
      availableLanguage: ['English'],
    },
  ],
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'B.No. 28, 2nd Floor, H.No. 207, Khatodra Bethi Colony',
    addressLocality: 'Surat',
    addressRegion: 'Gujarat',
    postalCode: '395002',
    addressCountry: 'IN',
  },
};

export const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Taiga Sourcing',
  url: SITE_URL,
};

export const breadcrumbSchema = (items) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, i) => ({
    '@type': 'ListItem',
    position: i + 1,
    name: item.name,
    item: `${SITE_URL}${item.path}`,
  })),
});

export const serviceSchema = (category, path) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: `${category.title} Sourcing`,
  name: `${category.title} Sourcing from India`,
  description: category.overview,
  provider: { '@type': 'Organization', name: 'Taiga Sourcing', url: SITE_URL },
  areaServed: 'Worldwide',
  url: `${SITE_URL}${path}`,
});

export const articleSchema = (post, path) => ({
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: post.title,
  description: post.excerpt,
  image: post.image,
  datePublished: post.date,
  author: { '@type': 'Organization', name: 'Taiga Sourcing', url: SITE_URL },
  publisher: {
    '@type': 'Organization',
    name: 'Taiga Sourcing',
    logo: { '@type': 'ImageObject', url: `${SITE_URL}/logo-navy.png` },
  },
  mainEntityOfPage: `${SITE_URL}${path}`,
});
